import React from "react";
import { useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import {
  emptyError,
  invalidTextFieldError,
  isBlank,
  isValidEmail,
  useUpdateIncluded,
} from "../../../utils/commonUtils";
import TextField from "./TextField";

const ContactEmail = observer(({ FeedbackStore }) => {
  const key = "email";
  const { feedback, updateError, updateValue, updateIncluded, contactByEmail } =
    FeedbackStore;
  const email = feedback.email;
  const msgs = useMessageGetter("feedback.form.email");

  // Update included property when contactByEmail value changes
  useUpdateIncluded(key, contactByEmail, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(email.value)) {
      updateError(key, emptyError(msgs));
    } else {
      updateError(
        key,
        isValidEmail(email.value) ? false : invalidTextFieldError(msgs)
      );
    }
  };

  if (!contactByEmail) return null;

  return (
    <TextField
      fieldName={key}
      type={key}
      autocomplete={key}
      value={email.value}
      error={email.error}
      handleOnChange={handleOnChange}
      handleOnBlur={handleOnBlur}
      maxLength={160}
    />
  );
});

export default inject("FeedbackStore")(ContactEmail);
